import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import { ToastService } from 'src/app/core';
import { AmendedData, AuditHistory, AuditHistoryApi, CandidateProfile, ImmigrationProfile } from 'src/app/core/api.gen';
import { LoaderService } from 'src/app/core/loader.service';
import { critical_Fields } from 'src/app/exit/services/manage-access/critical-fields';
import { clDict } from 'src/app/immigration/services/manage-access/claims-dict';
import { nullSafe } from 'src/app/utils';
import { isNullOrUndefined } from '../../../app/core/utils';

@Component({
  selector: 'eos-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class HistoryComponent implements OnInit {
  @Input() candidateId: number;
  @Input() model: CandidateProfile | ImmigrationProfile;
  @Input() module: string;
  @Input() visatype: string;
  @Input() country: string;
  @Input() exitType: string;

  datasource: AuditHistory[] = [];
  amendedDataList: AmendedData[] = [];
  dataList: AmendedData[] = [];
  selectedItem: any;
  isLoading = true;
  historyEmpty = false;
  noMoreHistory = false;
  pageNumber = 0;
  isSizeExceeds = false;
  isCurrentProfile = true;
  displayTextKeys = [];


  pbProfileKeys = [
    { key: 'pbStatus', title: 'Pre-boarding status' },
    {
      key: 'EmployeeCategory',
      title: 'Employee category'
    },
    {
      key: 'OfficeLocationCountry',
      title: 'Office location country'
    },
    {
      key: 'OnboardingType',
      title: 'Onboarding type'
    },
    {
      key: 'CurrentVisaStatus',
      title: 'Current visa status'
    },
    {
      key: 'TransferType',
      title: 'Transfer type'
    },
    {
      key: 'TransferScenario',
      title: 'Transfer scenario'
    },
    {
      key: 'ImmigrationCaseType',
      title: 'Immigration case type'
    }
  ];

  immigrationKeys = [
    {
      key: 'ResidencyStatus',
      title: 'Residency status',
      field: 'residencyStatus.id'
    },
    {
      key: 'Nationality',
      title: 'Nationality',
      field: 'nationality.id'
    },
    {
      key: 'CurrentVisaStatus',
      title: 'Current status',
      field: 'visaStatus.id'
    },
    {
      key: 'ImmigrationCaseType',
      title: 'Immigration case type',
      field: 'immigrationCaseType.id'


    }, {
      key: 'SpecialExpat',
      title: 'Special expat',
      type: 'string',
      field: 'specialExpat'
    },
    {

      key: 'OnboardingType',
      title: 'Pre boarding type',
      field: 'onboardingType.id'

    },
    {

      key: 'ShortTermVisa',
      title: 'Short term Visa type',
      field: 'shortTermVisa.id'

    },
    {

      key: 'TypeOfRequest',
      title: 'Type of request',
      field: 'typeOfRequest.id'

    },

    {

      key: 'OfficeToBeVisited',
      title: 'Office to be visited',
      field: 'officeToBeVisited.id'

    },

    {

      key: 'OfficeLE',
      title: 'Office legal entity',
      field: 'officeLE.id'

    },


    {

      key: 'HireType',
      title: 'Hire type',
      field: 'hireType.id'

    },


    {

      key: 'Gender',
      title: 'Gender',
      field: 'gender.id'

    }




  ];
  exitKeys = [
    {
      key: 'Status',
      title: 'Request status',
      field: 'status.id'
    },
    {
      key: 'NationalityType',
      title: 'Nationality type',
      field: 'nationalityType.id'
    },
    {
      key: 'Rank',
      title: 'Rank',
      field: 'globalRank.rankCode'
    },
    {
      key: 'ExitSubTpe',
      title: 'Exit type',
      field: 'exitSubType.id'
    },
    {
      key: 'OfficeLocationCity',
      title: 'Office location city',
      field: 'officeLocation.id'
    },
    {
      key: 'ServiceLine',
      title: 'Service line',
      field: 'serviceLine.id'
    },
    {
      key: 'SubServiceLine',
      title: 'SubService line',
      field: 'subServiceLine.id'
    }
  ];

  constructor(
    private auditHistory: AuditHistoryApi,
    public modal: NgbActiveModal,
    private toasterService: ToastService,
    private loader: LoaderService,

  ) {

  }

  ngOnInit() {

    this.decideOnTemplate();
    this.getHistory(true);
  }

  decideOnTemplate() {
    switch (this.module) {
      case "IMM":
        const cfileds = nullSafe(() => (clDict.find(x => x.key == this.visatype && x.country == this.country)
          .criticalFields), []);
        this.displayTextKeys = [...this.immigrationKeys.filter(y => cfileds.find(x => y.field == x)),
        ...this.immigrationKeys.filter(x => x.key == 'CurrentVisaStatus')];


        break;
      case "EXT":
        const critcal = nullSafe(() => (critical_Fields.find(x => x.key == this.exitType)
          .criticalFields), []);
        this.displayTextKeys = [...this.exitKeys.filter(y => critcal.find(x => y.field == x)),
        ...this.exitKeys.filter(x => x.key == 'Status')];
        break;

      case "PB":
        this.displayTextKeys = this.pbProfileKeys;
        break;

      default:
        this.displayTextKeys = this.pbProfileKeys;
        break;
    }
  }

  getHistory(isload: boolean) {
    this.loader.show();
    this.auditHistory.candidatePriority(
      this.candidateId,
      this.module,
      this.pageNumber,
      this.candidateId
    ).pipe(finalize(() => {
      this.isLoading = false;
      this.loader.clear();
    })).subscribe(resp => {
      // this.datasource = [];
      if (this.pageNumber === 0 && !resp.auditHistoryList.length) {
        this.historyEmpty = true;
      } else if (!resp.auditHistoryList.length) {
        this.noMoreHistory = true;
        this.toasterService.success('No more history to show for this candidate');
      } else {
        resp.auditHistoryList.forEach(data => {
          data.newData = JSON.parse(data.newData);
          data.modifiedDate = new Date(data.modifiedDate);
          this.datasource.unshift(data);
        });
        if (isload) {
          this.amendedDataList = resp.amendedDataList;
        }
        this.isSizeExceeds = resp.isSizeExceeds;
      }
    });
  }

  LoadAmendedData(event, amendData: AmendedData, last: boolean) {
    this.pageNumber = 0;
    if (!last) {
      this.isCurrentProfile = false;
    } else {
      this.isCurrentProfile = true;
    }
    this.selectedItem = amendData;
    this.candidateId = amendData.candidateProfileId;
    this.getHistory(false);
  }


  loadPrevious() {
    this.pageNumber += 1;
    this.getHistory(false);
  }

  isDifferent(key, index, last) {
    if (!last) {
      if (
        (!isNullOrUndefined(this.datasource[index].newData[key]) && !isNullOrUndefined(this.datasource[index + 1].newData[key]))
        && (this.datasource[index].newData[key]['DisplayText'] !== this.datasource[index + 1].newData[key]['DisplayText'])) {
        return 'text-difference';
      }
    } else if (this.isCurrentProfile && last) {
      return 'text-latest'
    }
    return '';
  }

}
